export const HELP_DESK_TICKET_SPLIT_UPDATE_MESSAGE = 'HELP_DESK_TICKET_SPLIT_UPDATE_MESSAGE';